import { makeStyles, Typography } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import classNames from 'classnames'
import moment from 'moment'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'
import { useCalendar } from '../CalendarContext'

const useStyles = makeStyles<Theme, { hideWeekends?: boolean }>((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.25)
  },
  dayName: {
    color: theme.paintscout.palette.brand.Neutral.P60,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
    lineHeight: 1
  },
  todayDayName: {
    color: theme.paintscout.palette.brand.Neutral.P30
  },
  dayNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    height: '24px',
    padding: theme.spacing(0, 0.75),
    borderRadius: theme.borderRadius.md,
    color: theme.paintscout.palette.brand.Neutral.P60,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 600,
    lineHeight: 1
  },
  todayDayNumber: {
    backgroundColor: theme.paintscout.palette.primary,
    color: theme.palette.common.white
  }
}))

export default function WeekColumnHeader(props: HeaderProps) {
  const { date } = props
  const { hideWeekends } = useCalendar()
  const classes = useStyles({ hideWeekends })

  const isWeekend = date.getDay() === 0 || date.getDay() === 6
  if (isWeekend && hideWeekends) {
    return null
  }

  const momentDate = moment(date)
  const isToday = momentDate.isSame(moment(), 'day')

  return (
    <div className={classes.root}>
      <Typography component="span" className={classNames(classes.dayName, { [classes.todayDayName]: isToday })}>
        {momentDate.format('ddd')}
      </Typography>
      <span className={classNames(classes.dayNumber, { [classes.todayDayNumber]: isToday })}>
        {momentDate.format('D')}
      </span>
    </div>
  )
}
